<template>
  <div class="">
    <PageHeader label="Mercury API key and token required"></PageHeader>
    
    <div class="w-1/2 pb-12">
      <div class="text-base mt-8">
        In order to download data from your Mercury, you will need to save 
        two pieces of information in Brokerpad - 
        <span class="text-blue-500 font-semibold">API key</span>
        and
        <span class="text-blue-500 font-semibold">API secret</span>.

        Together, they allow {{ getAppName }} secure way to access your
        Mercury data.
      </div>

      <div class="text-base mt-4">
        To find them, you will first need to login to your Mercury account and go to
        <span class="text-blue-500">Admin</span> page.
      </div>

      <div class="text-base mt-4 border-4">
        <img src="/static/img/mercury-admin.jpg" />
      </div>

      <div class="text-base mt-4">
        Next, click on the <span class="text-blue-500">Integrations</span> and you will
        see both API key and API secret values.
      </div>

      <div class="text-base mt-4 border-4">
        <img src="/static/img/mercury-api.jpg" />
      </div>

      <div class="text-base mt-6">
        Copy those two values and then save them in 
        <router-link :to="{
          name : 'broker-account',
          params : {
            brokerId : $store.state[$store.state.view + 'Module'].broker.id
          }
        }"
        tag="a"
        class="text-blue-500 no-underline hover:underline">My account</router-link> page.
      </div>

      <div class="text-base mt-6">
        Your {{ getAppName }} account is now ready to start accessing your Mercury.
      </div>
    </div>
  </div>
</template>

<script>
  import PageHeader from '@/shared/components/headers/PageHeader'

  export default {
    components: {
      PageHeader,
    },
  }
</script>